import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrLabel } from ".";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import { Switch } from "@mui/material";
import classNames from "classnames";
const StyledSwitch = styled(Switch)(props => ({
    color: "red",
    padding: 0,
    "&.MuiSwitch-root": {
        overflow: "visible",
        width: props.size === "small" ? 32 : 44,
        height: props.size === "small" ? 18 : 24,
    },
    "& .MuiSwitch-switchBase": {
        opacity: 1,
        padding: 0,
        margin: 3,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: props.size === "small" ? "translateX(14px)" : "translateX(20px)",
            color: palette.white,
            "& + .MuiSwitch-track": {
                backgroundColor: palette["maven-blue-dark"],
                border: `1px solid ${palette["maven-blue-dark"]}`,
                opacity: 1,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                backgroundColor: palette.bg010,
                border: `1px solid ${palette.grey025}`,
                opacity: "1 !important",
            },
            "& .MuiSwitch-thumb": {
                backgroundColor: palette.white,
            },
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            backgroundColor: palette.grey030,
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: props.size === "small" ? 12 : 18,
        height: props.size === "small" ? 12 : 18,
        backgroundColor: palette.grey040,
        boxShadow: "none",
    },
    "& .MuiSwitch-track": {
        borderRadius: "300px",
        backgroundColor: props.disabled ? palette.grey010 : palette.white,
        opacity: 1,
        border: `1px solid ${palette.grey025}`,
        width: props.size === "small" ? 30 : 42,
        height: props.size === "small" ? 16 : 22,
    },
    "& .Mui-disabled + .MuiSwitch-track": {
        opacity: 1,
    },
}));
export function GrSwitch({ label, className, ...props }) {
    var _a, _b, _c;
    const labelStyle = {
        ...typography["Content.Body03"],
        padding: "0 2px",
        color: props.disabled ? palette.grey030 : palette.grey090,
    };
    return (_jsxs(GrStack, { className: "GrSwitch-wrapper", display: "inline-flex", flexDirection: (_a = label === null || label === void 0 ? void 0 : label.flexDirection) !== null && _a !== void 0 ? _a : "row", gap: (_b = label === null || label === void 0 ? void 0 : label.gap) !== null && _b !== void 0 ? _b : "6px", alignItems: ((_c = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _c === void 0 ? void 0 : _c.includes("column")) ? "flex-start" : "center", justifyContent: props.justifyContent, children: [(label === null || label === void 0 ? void 0 : label.text) && _jsx(GrLabel, { htmlFor: props.id, style: labelStyle, ...label }), _jsx(StyledSwitch, { className: classNames("GrSwitch", className), ...props })] }));
}
//# sourceMappingURL=GrSwitch.js.map